module.exports = __webpack_public_path__ + "media/images/common/email-sent/email-sent-4afa128fa90b361e37284e679314b24e.jpeg";